import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatAutocompleteModule, MatFormFieldModule, MatIconModule, MatInputModule, MatOptionModule, MatTooltipModule } from '@angular/material';
import { AdminAddonsListComponent } from './admin-addons-list.component';
import { AuthGuardService } from 'app/main/pages/authentication/auth-guard.service';
import { TableModule } from 'primeng/table';
import { MultiSelectModule } from 'primeng/primeng';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProgressBarModule } from 'angular-progress-bar';

const routes = [
    { path: '', redirectTo: 'admin-addons-list', pathMatch: 'full', canActivate: [AuthGuardService] },
    { path: 'admin-addons-list', component: AdminAddonsListComponent, canActivate: [AuthGuardService] },
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        MatTooltipModule,
        TableModule,
        MatIconModule,
        MultiSelectModule,
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        ReactiveFormsModule,
        MatOptionModule,
        ProgressBarModule,
        MatAutocompleteModule
    ],
    declarations: [
        AdminAddonsListComponent
    ]
})
export class AdminAddonsListModule { }
